import { render, staticRenderFns } from "./ProductPackage.vue?vue&type=template&id=3ebf5197&scoped=true&"
import script from "./ProductPackage.vue?vue&type=script&lang=js&"
export * from "./ProductPackage.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackage.vue?vue&type=style&index=0&id=3ebf5197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf5197",
  null
  
)

export default component.exports